jQuery(document).on('click', '.footer-menu-toggle', function (e) {
	e.preventDefault();
	jQuery(this).next().slideToggle(400);
	jQuery(this).toggleClass('open');
	if (jQuery(this).attr('aria-expanded') === 'true') {
		jQuery(this).attr('aria-expanded', 'false');
	} else {
		jQuery(this).attr('aria-expanded', 'true');
	}
});

jQuery(window).on('load, resize', function () {
	if (jQuery(window).width() > 760) {
		jQuery('.footer-menu').removeAttr('style');
		jQuery('.footer-menu-toggle').removeClass('open');
	}
});
